import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { SelectItem } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { forkJoin } from 'rxjs';

import { DivisionPoliticaService } from '../../_services/division-politica.service';
import { NavService } from '../../_services/_nav.service';
import { ListaService } from '../../_services/lista.service';
import { PagaduriaService } from '../../_services/pagaduria.service';
import { TipoOcupacionConfiguracionService } from '../../_services/tipo-ocupacion-configuracion.service';
import { ProductoDestinoService } from '../../_services/producto-destino.service';
import { ConstanteService } from '../../_services/constante.service';
import { ProductoService } from '../../_services/producto.service';
import { CreditoService } from '../../_services/credito.service';

import { DivisionPolitica } from '../../_models/division-politica';
import { ResultadoSimulacion } from '../../_models/simulador-producto-seguros';
import { SimuladorCredito } from '../../_enums/enum';


@Component({
  selector: 'app-simulador-pantalla-general',
  templateUrl: './simulador-pantalla-general.component.html',
  styleUrls: ['./simulador-pantalla-general.component.scss']
})
export class SimuladorPantallaGeneralComponent implements OnInit {

  formulario: FormGroup;
  submitted = false;
  guardando = false;

  lisTodasOcupacionesTodas: any[] = [];

  listTiposProductoBancarios: SelectItem[] = [];
  listTiposOcupaciones: SelectItem[] = [];
  listTiposFormaPago: SelectItem[] = [];
  listTiposPagaduria: SelectItem[] = [];
  listTiposDestinos: SelectItem[] = [];
  listTiposProductos: SelectItem[] = [];
  listTiposFrecuencias: SelectItem[] = [];
  listTiposdeCuotas: SelectItem[] = [];
  listTiposTasasProducto: SelectItem[] = [];
  listTiposFondosGarantias: SelectItem[] = [];

  resCiudades: DivisionPolitica[] = [];
  ciudad: DivisionPolitica = new DivisionPolitica();
  resultadoSimulacion: ResultadoSimulacion;
  constOCUCIU: string[] = [];
  listSeguros: any[] = [];
  listaProductosTodos: any[] = [];
  cargando: boolean = false;
  nombreCredit: string = '';
  nombreCuota: string = '';
  nombreTasa: string = '';
  nombreGarantia: string = '';
  isExpanded: boolean = false;
  isExpandedOtrosCargos: boolean = false;
  isCredit: boolean = true;
  isCiudad: boolean = false;
  isFormaPago: boolean = false;
  isPagaduria: boolean = false;
  isCampoProducto: boolean = false;
  isCamposHabilitados: boolean = false;
  isFondosGarantias: boolean = false;
  isResultadoSimulacion: boolean = false;
  isNoSeguros: boolean = false;
  isCampoCuota: boolean = true;
  isCampoTasa: boolean = true;
  isDestino: boolean = false;
  isCampoGarantia: boolean = true;
  valorTotalSeguros: number = 0;
  productoFalsoCombo: string = null;
  frecuenciaFalsoCombo: string = null;
  constructor(
    private fb: FormBuilder,
    private divPolServicio: DivisionPoliticaService,
    private nav: NavService,
    private listaService: ListaService,
    private pagaduriaService: PagaduriaService,
    private tipoOcupacionConfiguracionService: TipoOcupacionConfiguracionService,
    private conConstanteServicio: ConstanteService,
    private productoDestinoService: ProductoDestinoService,
    private productoService: ProductoService,
    private creditoService: CreditoService,
    private router: Router,
    private ref: DynamicDialogRef,
  ) { }
  ngOnInit() {
    this.cargarFormulario();
    this.cargaInicial();
  }

  cargaInicial() {
    this.cargando = true;
    forkJoin(
      this.listaService.getMasterDetails("ListasTiposProductosBancarios"),
      this.listaService.getMasterAllDetails("ListasTiposVinculaciones"),
      this.listaService.getMasterDetails("ListasFormasPagos"),
      this.pagaduriaService.getByCodigo("CNFACT"),
      this.conConstanteServicio.getByCode("OCUCIU")
    ).subscribe(
      async([listTiposProductoBancarios,
        ListasTiposVinculaciones,
        listTiposFormaPago, listTiposPagaduria, constOCUCIU]) => {

        const listTipProdBancarios = listTiposProductoBancarios.filter( s=> s.codigo != 'PROAHO');

        if ( listTipProdBancarios && listTipProdBancarios.length > 1 ) {
          listTipProdBancarios.forEach( x => {
            this.listTiposProductoBancarios.push({ label: x.nombre, value: x.idLista,});
          });
        }else if ( listTipProdBancarios && listTipProdBancarios.length == 1 ) {
          this.isCredit = false;
          this.nombreCredit = listTipProdBancarios[0].nombre;
          this.f.idTipoProductoBancario.setValue( listTipProdBancarios[0].idLista );
        }


        if ( ListasTiposVinculaciones && ListasTiposVinculaciones.length > 0 ) {
          const { idLista } = ListasTiposVinculaciones.find( vin => vin.codigo === SimuladorCredito.TITULAR );
          this.lisTodasOcupacionesTodas = await this.tipoOcupacionConfiguracionService.listadoObliganacionesSegmentos('ListasTiposVinculaciones', idLista, 'VINOCU' ).toPromise();
          this.lisTodasOcupacionesTodas.sort((a, b) => a.secuencia - b.secuencia);
          this.lisTodasOcupacionesTodas.forEach( x => {
            this.listTiposOcupaciones.push({ label: x.nombreTipoOcupacion, value: x.idTipoOcupacionConfiguracion,});
          });
        }
        if ( listTiposFormaPago && listTiposFormaPago.length > 0 ) {
          listTiposFormaPago.forEach( x => {
            this.listTiposFormaPago.push({ label: x.nombre, value: x.idLista,});
          });
        }
        if ( listTiposPagaduria && listTiposPagaduria.length > 0 ) {
          listTiposPagaduria.forEach( x => {
            this.listTiposPagaduria.push({ label: x.razonSocial, value: x.idPagaduria,});
          });
        }
        if( constOCUCIU && constOCUCIU.valor && constOCUCIU.indicadorHabilitado ){
          this.constOCUCIU = constOCUCIU.valor.split(',');
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
      }
    )
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idTipoProductoBancario: [ null ],
      idTipoOcupacionConfiguracion: [ null, [ Validators.required ] ],
      idCiudad: [ null, [ Validators.required ] ],
      ciudad: [ null ],
      idFormaPago: [ null, [ Validators.required ] ],
      idTiposPagaduria: [ null],
      idDestino: [ null, [ Validators.required ] ],
      monto: [ null, [ Validators.required ] ],
      idProducto: [ null, [ Validators.required ] ],
      idFrecuenciaProducto: [ null, [ Validators.required ] ],
      numeroCuotas: [ null, [ Validators.required ] ],
      idTipoCuota: [ null, [ Validators.required ] ],
      idTipoTasaProducto: [ null, [ Validators.required ] ],
      idGarantiaIdonea: [ null, [ Validators.required ] ],
      puntosDescuento: [ null],
      tasaEspecial: [ null],
    });
  }

  get f() {
    return this.formulario.controls;
  }

  buscar( busqueda: any ) {
    this.divPolServicio.getAllCities( busqueda.query ).subscribe(
      lis => { this.resCiudades = lis } );
  }

  limpiarCiudad() {
    this.f.idCiudad.setValue( null );
  }

  capturarLugar( lugar: any ) {
    if ( lugar.value.codigoTipo !== '3' ) {
      this.showMessage('LBL_INFORMACION', 'PROSPECTO.MSG_ERRORUBICACION');
      this.limpiarCiudad();
    } else {
      this.f.idCiudad.setValue( lugar.value.idDivisionPolitica );
    }
  }

  limpiarFormulario() {
    this.formulario.reset();
    this.submitted = false;
    this.listSeguros = [];
    this.isNoSeguros = false;
    this.resultadoSimulacion = null;
    this.isResultadoSimulacion = false;
    this.valorTotalSeguros = 0;
    this.seterarCampos();
    this.isCiudad = false;
    this.isFormaPago = false;
    this.isPagaduria = false;
    this.isCampoProducto = false;
    this.isCamposHabilitados = false;
    this.isCampoCuota = true;
    this.isCampoTasa = true;
    this.isFondosGarantias = false;
    this.isDestino = false;
  }

  toggleAccordion( item: any ) {
    item.isExpanded = !item.isExpanded;
  }

  toggleAccordionOtrosCargos( item: any ) {
    item.isExpandedOtrosCargos = !item.isExpandedOtrosCargos;
  }

  onChangeOcupacion( event ) {
    this.listTiposDestinos = [];
    this.cargando = true;
    this.productoDestinoService.listDestinoOcupacion( this.f.idTipoOcupacionConfiguracion.value ).subscribe(
      listDestinos =>{
        if ( listDestinos && listDestinos.length > 0 ) {
          listDestinos.forEach( x => {
            this.listTiposDestinos.push({ label: x.nombre, value: x.idLista,});
          });
        }
        const ocupacion = this.lisTodasOcupacionesTodas.find( x => x.idTipoOcupacionConfiguracion === event.value );
        if( this.constOCUCIU && this.constOCUCIU.length > 0 && ocupacion ){
          if ( this.constOCUCIU.includes( ocupacion.codigoTipoOcupacion ) ) {
            this.isCiudad = true;
            this.f.idCiudad.setValidators( [ Validators.required ] );
            this.f.idCiudad.updateValueAndValidity();
          } else {
            this.isCiudad = false;
            this.f.ciudad.setValue( null );
            this.f.idCiudad.setValue( null );
            this.f.idCiudad.setValidators( [] );
            this.f.idCiudad.updateValueAndValidity();
          }
        }else{
          this.isCiudad = true;
        }
        if( ocupacion.indicadorPagaduria ) {
          this.isFormaPago = true;
          this.f.idFormaPago.setValue( null );
          this.f.idTiposPagaduria.setValue( null );
        }else{
          this.isFormaPago = false;
          this.isPagaduria = false;
          const formaPago = this.listTiposFormaPago.find( x => x.label.toLocaleUpperCase() === SimuladorCredito.PERSONAL );
          this.f.idFormaPago.setValue( formaPago && formaPago.value ? formaPago.value : null );
        }
        if ( this.listTiposDestinos && this.listTiposDestinos.length > 0 ) {
          this.isDestino = true;
        }
        this.cargando = false;
       });
  }

  onChangeFormaPago( event ) {
    const formaPago = this.listTiposFormaPago.find( x => x.value === event.value );
    if( formaPago && formaPago.label.toLocaleUpperCase() === SimuladorCredito.LIBRANZA ) {
      this.isPagaduria = true;
    }else{
      this.isPagaduria = false;
    }
  }

  limpiarOtroCampo(campo: string) {
    if (campo === 'puntosDescuento' && this.formulario.get('puntosDescuento').value) {
      this.f.tasaEspecial.setValue(null);
    } else if (campo === 'tasaEspecial' && this.formulario.get('tasaEspecial').value) {
      this.f.puntosDescuento.setValue(null);
    }
  }

  verificarCampos() {
    const valoresFormulario = this.formulario.value;
    const camposRequeridos = {
      idTipoOcupacionConfiguracion: valoresFormulario.idTipoOcupacionConfiguracion,
      idDestino: valoresFormulario.idDestino,
      monto: valoresFormulario.monto,
      idFormaPago: valoresFormulario.idFormaPago
    };
    if (this.isCiudad) {
      camposRequeridos['idCiudad'] = valoresFormulario.idCiudad;
    }
    if (valoresFormulario.idProducto) {
      this.isCamposHabilitados = false;
      this.isCampoCuota = true;
      this.isCampoTasa = true;
      this.isCampoGarantia = true;
      this.listSeguros = [];
      this.isNoSeguros = false;
      this.resultadoSimulacion = null;
      this.isResultadoSimulacion = false;
      this.valorTotalSeguros = 0;
      this.f.idProducto.setValue(null);
      this.seterarCampos();
    }
    const camposLlenos = Object.values(camposRequeridos).every(value => value !== null && value !== undefined && value !== '');
    if (camposLlenos) {
      this.listTiposProductos = [];
      this.listaProductosTodos = [];
      this.cargando = true;
      this.productoService.simuladorProductoSeguros( camposRequeridos ).subscribe(
        productos => {
          if ( productos && productos.length > 0 ) {
            this.listaProductosTodos = productos;
            this.isCampoProducto = true;
            productos.forEach( x => {
              this.listTiposProductos.push( { label: x.nombre, value: x.idProducto } );
            });
            if (this.listTiposProductos.length === 1) {
              this.f.idProducto.setValue(this.listTiposProductos[0].value);
              this.productoFalsoCombo = this.listTiposProductos[0].label;
              this.lanzarServicioGeneral();
            } else {
              this.productoFalsoCombo = null;
            }
          }else {
            this.isCampoProducto = false;
            this.showMessage('LBL_INFORMACION', 'SIMULADORCREDITO.LBL_NOHAYPRODUCTO');
          }
          this.cargando = false;
        },
        error => {
          this.cargando = false;
        }
      )
    }
  }

  lanzarServicioGeneral() {
    const valoresFormulario = this.formulario.value;
    this.listSeguros = [];
    this.isNoSeguros = false;
    this.valorTotalSeguros = 0;
    this.listTiposFrecuencias = [];
    this.listTiposdeCuotas = [];
    this.listTiposTasasProducto = [];
    this.listTiposFondosGarantias = [];
    this.resultadoSimulacion = null;
    this.isResultadoSimulacion = false;
    this.isCampoCuota = true;
    this.isCampoTasa = true;
    this.isCampoGarantia = true;
    this.seterarCampos();
    this.cargando = true;
    this.productoService.simuladorCamposGeneralIdTipoOcupacion( valoresFormulario.idProducto, valoresFormulario.monto, valoresFormulario.idTipoOcupacionConfiguracion ).subscribe(
      res => {
        this.isCamposHabilitados = true;

        if( res.itemsListasFrecuenciasProductos && res.itemsListasFrecuenciasProductos.length > 0 ) {
          res.itemsListasFrecuenciasProductos.forEach( x => {
            this.listTiposFrecuencias.push( { label: x.nombre, value: x.idLista } );
          })
        }

        if( res.itemslistasTiposCuotas && res.itemslistasTiposCuotas.length > 1 ) {
          res.itemslistasTiposCuotas.forEach( x => {
            this.listTiposdeCuotas.push( { label: x.nombre, value: x.idLista } );
          })
        }else if( res.itemslistasTiposCuotas && res.itemslistasTiposCuotas.length === 1 ) {
          this.isCampoCuota = false;
          this.nombreCuota = res.itemslistasTiposCuotas[0].nombre;
          this.f.idTipoCuota.setValue( res.itemslistasTiposCuotas[0].idLista );
        }

        if( res.itemsListasTiposTasasProductos && res.itemsListasTiposTasasProductos.length > 1 ) {
          res.itemsListasTiposTasasProductos.forEach( x => {
            this.listTiposTasasProducto.push( { label: x.nombre, value: x.idLista } );
          })
        }else if( res.itemsListasTiposTasasProductos && res.itemsListasTiposTasasProductos.length === 1 ) {
          this.isCampoTasa = false;
          this.nombreTasa = res.itemsListasTiposTasasProductos[0].nombre;
          this.f.idTipoTasaProducto.setValue( res.itemsListasTiposTasasProductos[0].idLista );
        }

        if( res.garantiasIdoneas && res.garantiasIdoneas.length > 1 ) {
          res.garantiasIdoneas.forEach( x => {
            this.listTiposFondosGarantias.push( { label: x.nombre, value: x.idGarantiaIdonea } );
          })
          this.isFondosGarantias = true;
        }else if( res.garantiasIdoneas && res.garantiasIdoneas.length === 1 ) {
          this.isFondosGarantias = true;
          this.isCampoGarantia = false;
          this.nombreGarantia = res.garantiasIdoneas[0].nombre;
          this.f.idGarantiaIdonea.setValue( res.garantiasIdoneas[0].idGarantiaIdonea );
        }else{
          this.isFondosGarantias = false;
          this.f.idGarantiaIdonea.setValidators( [] );
          this.f.idGarantiaIdonea.updateValueAndValidity();
        }

        if( res.simulacionesSegurosDTO && res.simulacionesSegurosDTO.seguros && res.simulacionesSegurosDTO.seguros.length > 0
          || res.simulacionesSegurosDTO.segurosPlanes && res.simulacionesSegurosDTO.segurosPlanes.length > 0 ) {
            this.listSeguros.push( ...res.simulacionesSegurosDTO.seguros);
            this.listSeguros.push( ...res.simulacionesSegurosDTO.segurosPlanes);
            this.isNoSeguros = false;
        }else{
          this.isNoSeguros = true;
        }
        if (this.listTiposFrecuencias.length === 1) {
          this.f.idFrecuenciaProducto.setValue(this.listTiposFrecuencias[0].value);
          this.frecuenciaFalsoCombo = this.listTiposFrecuencias[0].label;
        } else {
          this.frecuenciaFalsoCombo = null;
        }
        this.cargando = false;
      },
      error => {
        this.cargando = false;
      }
    )
  }

  private showMessage( titulo: string, mensaje: string, severity: string = 'info' ) {
    this.nav.setMesage( 0, {
      severity: severity, summary: this.nav.buscarMensaje( titulo ),
      detail: this.nav.buscarMensaje( mensaje )
    } );
  }

  seterarCampos() {
    this.f.idFrecuenciaProducto.setValue(null);
    this.f.idTipoCuota.setValue(null);
    this.f.tasaEspecial.setValue(null);
    this.f.idTipoTasaProducto.setValue(null);
    this.f.puntosDescuento.setValue(null);
    this.f.numeroCuotas.setValue(null);
    this.f.idGarantiaIdonea.setValue(null);
    this.submitted = false;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.f.puntosDescuento.value == 0 ) {
      this.f.puntosDescuento.setValue( null );
    }
    if ( this.f.tasaEspecial.value == 0 ) {
      this.f.tasaEspecial.setValue( null );
    }
    if ( this.formulario.valid ) {
      this.cargando = true;
      const valoresFormulario = this.formulario.value;
      const camposRequeridos = {
        idProducto: valoresFormulario.idProducto,
        idFrecuenciaProducto: valoresFormulario.idFrecuenciaProducto,
        idTipoCuota: valoresFormulario.idTipoCuota,
        tasaEspecial: valoresFormulario.tasaEspecial,
        idTipoTasaProducto: valoresFormulario.idTipoTasaProducto,
        puntosDescuento: valoresFormulario.puntosDescuento,
        monto: valoresFormulario.monto,
        numeroCuotas: valoresFormulario.numeroCuotas,
        idGarantiaIdonea: valoresFormulario.idGarantiaIdonea,
        idDestino: valoresFormulario.idDestino,
        idTipoOcupacionConfiguracion : valoresFormulario.idTipoOcupacionConfiguracion
      };
      this.creditoService.simularCredito( camposRequeridos ).subscribe(
        res => {
          if ( res && res.mensaje ){
            this.showMessage('LBL_INFORMACION', res.mensaje );
            this.isResultadoSimulacion = false;
            this.cargando = false;
            return;
          }
          if (res && res.tasas && res.calculos) {
            if (res.tasas.length === 2) {

              res.calculos.sort((a, b) => a.tasa - b.tasa);

              const mayor = Math.max(...res.tasas);
              const menor = Math.min(...res.tasas);

              res.calculos.forEach(calculo => {
                if (calculo.tasa === mayor) {
                  calculo.ordenTasa = SimuladorCredito.MAYOR;
                  calculo.isExpanded = false;
                  calculo.isExpandedOtrosCargos = false;
                } else if (calculo.tasa === menor) {
                  calculo.ordenTasa = SimuladorCredito.MENOR;
                  calculo.isExpanded = false;
                  calculo.isExpandedOtrosCargos = false;
                }
              });
            } else if (res.tasas.length === 1) {
              res.calculos.forEach(calculo => {
                calculo.ordenTasa = SimuladorCredito.APROXIMADA;
                calculo.isExpanded = false;
                calculo.isExpandedOtrosCargos = false;
              });
            }
          }

          if (res && res.segurosValorSimulacionDTOList && res.segurosPlanesValorSimulacionDTOS) {
            res.segurosUnificados = [...res.segurosValorSimulacionDTOList, ...res.segurosPlanesValorSimulacionDTOS];
          }

          if (res && res.segurosUnificados) {
            this.valorTotalSeguros = res.segurosUnificados.reduce((total, seguro) => total + (seguro.valor || 0), 0);
          }
          this.resultadoSimulacion = res;
          this.isResultadoSimulacion = true;
          this.cargando = false;
        },
        error => {
          this.cargando = false;
        }
      )
    }
  }
  generateUUID(): string {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16).toUpperCase();
    });
    return uuid;
  }

  crearSolicitud() {
    const validarProducto = this.listaProductosTodos.find(x => x.idProducto === this.f.idProducto.value).codigo === 'CR14';
    if ( validarProducto ) {
      this.showMessage('LBL_INFORMACION', 'SIMULADORCREDITO.MSG_NOCHANCONCHAN' );
      return;
    }
    const idSimulador = this.generateUUID();
    const valoresFormulario = this.formulario.value;
    const simuladorCreditoData = {
      ...valoresFormulario,
      idSimulador: idSimulador
    }
    localStorage.setItem(`${idSimulador}`, JSON.stringify(simuladorCreditoData));
    this.router.navigate([`pys/gestion-comercial/flujo-venta-proceso/simulador/${idSimulador}`]);
    this.ref.close();
  }

  preventEnter(event: KeyboardEvent, nombreCampo: string): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.limpiarOtroCampo(nombreCampo);
    }
  }
}
